import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import MainMeterSelector from './MainMeterSelector';
import SubMeterSelector from './SubMeterSelector';
import SiteService from './SiteService';
import EndeksInput from './EndeksInput';
import MeterReadingTimeLine from './MeterReadingTimeLine';
import MeterReadingTimeline from './MeterReadingTimeLine';

const MeterReadingList4TimeLine = ({ isUpdate }) => {
    const [mainMeterId, setMainMeterId] = useState(null);
    const [subMeterId, setSubMeterId] = useState(null);
    const [meterReadings, setMeterReadings] = useState([]);

    useEffect(() => {
        setMeterReadings([]);

        if (subMeterId) {


            SiteService.getMeterReadingsTimeline(mainMeterId, subMeterId).then((res) => {
                setMeterReadings(res.data);
            });
        }
    }, [subMeterId]);

    return (
        <div className="card ">
            <h3 className="text-center">Sayaç Okuma Tüketim Tarihçesi</h3>
            <SubMeterSelector
                mainMeterId={mainMeterId}
                setMainMeterId={setMainMeterId}
                subMeterId={subMeterId}
                setSubMeterId={setSubMeterId}
            />
            <Box>
                <MeterReadingTimeline meterReadings={meterReadings} />
            </Box>
        </div>
    );
}
export default MeterReadingList4TimeLine;